<template>
   <div class="content-wrapper">
      <section class="content-header">
         <div class="row">
            <div class="col-xs-8">
               <h1>Search <span style="color:#00a65a">{{com_TVOwnerName()}}</span> PIN</h1>
            </div>
            <div class="col-xs-4">
               <router-link :to="{name: 'FlexAddSinglePins'}" class="btn btn-sm btn-add">
                  <i class="fa fa-plus-square"></i> Generate TV Single PIN
               </router-link>
               <a class="btn btn-sm btn-add refresh" @click="refreshNow">
                  <i class="fa fa-refresh"></i> Refresh
               </a>
            </div>
         </div>
      </section>
      <section class="content">
         <form v-on:submit.prevent="dopagination(0)">
         <div class="row">
            <div class="col-xs-6 col-sm-2 form-group">
               <input placeholder="PIN" type="text" name="login" v-model="login" id="login" class="form-control input-sm" value="">
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <select title="" name="idLots" id="lots_id" class="form-control input-sm select2" v-model="lots_id"  v-select="lots_id" @change="dopagination(0)">
                  <option value="0">Select Batch Name</option>
                  <option v-for="(data) in batchArr" :key="data.id" value="" :value="data.lot_id">
                     {{data.description}}
                  </option>
               </select>
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <input placeholder="Range Of Batch Pin: 1-9" disabled type="text" name="batch_pin_serial" id="batch_pin_serial" v-model="batch_pin_serial" class="form-control input-sm" value="">
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <select title="" name="id_reseller" id="id_reseller" v-model="id_reseller" v-select="id_reseller" class="form-control input-sm select2" @change="dopagination(0)">
                  <option value="">All Reseller</option>
                  <option v-for="(data, index) in reseller_list" :key="data.id" :value="index">{{data}}</option>
               </select>
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <select title="" name="status" id="status" v-model="status" v-select="status" class="form-control input-sm select2" @change="dopagination(0)">
                  <option value="">All</option>
                  <option value="1">Active PIN</option>
                  <option value="2">Inactive PIN</option>
                  <option value="3">Expired PIN</option>
                  <option value="4">Subscribed PIN</option>
                  <option value="5">Not subscribed (Active)</option>
               </select>
            </div>

            <div class="col-xs-6 col-sm-2 form-group">
               <select title="" name="user_type" id="user_type" v-model="user_type" v-select="user_type" class="form-control input-sm select2" @change="dopagination(0)">
                  <option value="">Pin Type ( All )</option>
                  <option value="1">Paid PIN</option>
                  <option value="3">Free PIN</option>
               </select>
            </div>

            <div class="col-xs-6 col-sm-2 form-group">
               <select title="" name="limit" id="limit" v-model="display_limit" v-select="display_limit" class="form-control input-sm select2" @change="dopagination(0)">
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="75">75</option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
               </select>
            </div>
            <div class="col-xs-6 col-sm-3 form-group pull-right btnRight">
               <button type="submit" class="btn btn-sm btn-submit">
                  <i class="fa fa-search"></i> Search
               </button>
            </div>
         </div>
         </form>


         <div class="row">
            <div class="col-sm-12">
               <div class="alert alert-info" v-if="alert_message">
                  {{alert_message}}
               </div>
            </div>
            <div class="col-md-12">
               <div class="box" id="pagination">
                  <form>
                     <div class="box-header">
                        <h3 class="box-title">
                           Total : {{totalData}} Showing {{dispplayFrom}} to {{dispplayTo}}
                           <div class="form-inline pull-right" id="activation1">
                              <label style="color: green;font-weight: bold">With Selected</label>
                              <div class="form-group">
                                 <select title="" id="activation_option1" name="activation" class="form-control input-sm" v-model="operation_type">
                                    <option value="1">Activate</option>
                                    <option value="2">Deactivate</option>
                                 </select>
                              </div>
                              <input class="btn btn-sm btn-submit" type="button" name="button" value="Submit" @click="mulOperation(1)"/>
                           </div>
                        </h3>
                     </div>
                     <div class="box-body">
                        <div class="table-responsive">
                           <table class="table table-0024 table-bordered table-striped">
                              <thead>
                                 <tr>
                                    <th class="tdCenter tdSN">SN</th>
                                    <th class="tdCenter">TV PIN</th>
                                    <th class="tdCenter">Password</th>
                                    <th class="tdCenter">TV Batch Name</th>
                                    <th class="tdCenter">B.Pin SL</th>
                                    <th class="tdCenter">Activate At</th>
                                    <th class="tdCenter">First Login</th>
                                    <th class="tdCenter">Expire Date</th>
                                    <th class="tdCenter">No of days</th>
                                    <th class="tdCenter">Subcription Plan</th>
                                    <th class="tdCenter">Status</th>
                                    <th class="tdCenter">
                                       <span class="thSelectAll">All</span>
                                       <input type="checkbox" id="check_all" @click="checkAll"/>
                                    </th>
                                    <th class="tdCenter" style="width: 60px">Action</th>
                                 </tr>
                              </thead>
                              <tbody>
                                 <tr v-for="(data, index) in pinListArr" :key="data.id">
                                    <td class="tdCenter tdSN">
                                       {{parseInt(sl) + index}}
                                    </td>
                                    <td class="tdCenter">
                                       <a href="#" title="View Device" class="colorbox" @click="loadDeviceList(data.id)">
                                          <span :class="data.user_type==3?'text-yellow':'text-green'">
                                             {{com_removeTVPinPrefix(data.username, userData.reseller4.tv_pin_prefix)}}
                                          </span>
                                       </a>
                                    </td>
                                    <td class="tdCenter" @dblclick="contentEdit(data.id);" @blur="updatePassword(data.id)" :original-value="data.value" :username="data.username" :id="'passWord-'+data.id">
                                       <span :id="'passwordShowDiv_'+data.id">
                                          <button type="button" @click="showPinPass(data.id)" class=" btn btn-sm btn-submit bg-yellow" style="border-radius: 2px"> <i class="fa fa-eye" ></i></button>
                                       </span>
                                    </td>
                                    <td class="tdCenter">
                                       {{data.lot_name}}
                                    </td>
                                    <td class="tdCenter">
                                       {{data.batch_pin_serial}}
                                    </td>
                                    <td class="tdCenter info">
                                       {{data.activate_at}}
                                    </td>
                                    <td class="tdCenter info">
                                       {{data.after_activate_first_login_at}}
                                    </td>
                                    <td class="tdCenter info">
                                       {{data.validity_date}}
                                    </td>
                                    <td class="tdCenter info">
                                       <span v-if="data.user_type==3">-</span>
                                       <span v-else>{{data.no_of_days}}</span>
                                    </td>
                                    <td class="tdCenter">
                                       {{data.description}}
                                    </td>
                                    <td class="tdCenter" v-if="data.status==1">
                                       <span class='label label-success'>Active</span>
                                    </td>
                                    <td class="tdCenter" v-else-if="data.status==2">
                                       <span class='label label-danger'>Inactive</span>
                                    </td>
                                    <td class="tdCenter" v-else>
                                       <span class='label label-warning'>Expire</span>
                                    </td>
                                    <td class="tdCenter">
                                       <input type="hidden" :value="data.status">
                                       <input class="user_id" name="user_id[]" type="checkbox" :value="data.id"/>
                                    </td>
                                    <td class="tdCenter" style="width:;">

                                       <a v-if="data.allowresetpin" title='Return Balance and Deactivate PIN' :class="data.has_return_request !=1 ? 'btn btn-sm text-danger':'btn btn-sm text-yellow'" @click="returnPin(data.id, data.has_return_request)" style="padding: 2px 5px; display: none;">
                                          <i class="fa fa-reply" aria-hidden="true"></i>
                                       </a>

                                       <a v-if="(data.status == 1 && data.udid && userData.reseller.pin_reset == 1 && userData.reseller4_id != 98 && userData.reseller4_id != 304 )" title='Reset UDID' class='btn btn-sm text-warning' @click="resetPin(data.id)" style="padding: 2px 5px;">
                                          <i class="fa fa-refresh" aria-hidden="true"></i>
                                       </a>
                                    </td>
                                 </tr>
                                 <tr v-if="pinListArr.length==0">
                                    <td colspan="17" class="tdCenter" style="padding: 30px 0;"><b>No Records
                                            Found</b></td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>

                        <div style="display: none;">
                           <div id="viewDeviceList">
                              <div class="box" style="padding: 20px;">
                                 <div class="box-header">
                                    <h3 class="box-title">
                                       <b></b> Device Info
                                    </h3>
                                 </div>
                                 <div class="box-body">
                                    <table class="table table-0024 table-bordered table-striped">
                                       <thead>
                                          <tr>
                                             <th class="tdCenter tdSN">SN</th>
                                             <th class="tdCenter">Device Type</th>
                                             <th class="tdCenter">Brand Price</th>
                                             <th class="tdCenter">Model</th>
                                             <th class="tdCenter">OS Name</th>
                                             <th class="tdCenter">OS Version</th>
                                             <th class="tdCenter">Architecture</th>
                                             <th class="tdCenter">App Version</th>
                                             <th class="tdCenter">Is Rooted</th>
                                             <th class="tdCenter">Created At</th>
                                          </tr>
                                       </thead>
                                       <tbody v-if="deviceArr.length > 0">
                                          <tr :class="val.actual_price==''?'warning':''" v-for="(val, index) in deviceArr" >
                                             <td class="tdCenter tdSN">{{++index}}</td>
                                             <td class="tdCenter">
                                                <span v-if="val.device_type==1">Android</span>
                                                <span v-if="val.device_type==2">IOS</span>
                                             </td>
                                             <td class="tdCenter">
                                                {{val.brand}}
                                             </td>
                                             <td class="tdCenter">
                                                {{val.model}}
                                             </td>
                                             <td class="tdCenter">
                                                {{val.os_name}}
                                             </td>
                                             <td class="tdCenter">
                                                {{val.os_version}}
                                             </td>
                                             <td class="tdCenter">
                                                {{val.os_platform}}
                                             </td>
                                             <td class="tdCenter">
                                                {{val.vpn_app_version}}
                                             </td>
                                             <td class="tdCenter">
                                                <span v-if="val.is_rooted_phone==1">Yes</span>
                                                <span v-else>No</span>
                                             </td>
                                             <td class="tdCenter">
                                                {{val.created_at}}
                                             </td>
                                          </tr>
                                       </tbody>
                                       <tbody v-else>
                                          <tr>
                                             <td colspan="10" class="tdCenter" style="padding: 30px 0px;"> No Records Found </td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                              </div>

                           </div>
                        </div>

                        <div class="pagination" v-if="last_page > 1">
                           <a v-if="prev_page_url" href="#" @click="dopagination(prevPage)" class="next">
                              « Previous
                           </a>
                           <span v-else class="disabled">« Previous</span>
                           <span v-if="last_page > max_display_pagination">
                              <span v-for="index in last_page">
                                 <span v-if="index==1||index==2">
                                    <span class="current" v-if="index==current_page">
                                       {{index}}
                                    </span>
                                    <span v-else>
                                       <a href="#" @click="dopagination(index)">
                                          {{index}}
                                       </a>
                                    </span>
                                    <span v-if="(index==2) && firstDotted">..</span>
                                 </span>
                                 <span v-if="randomPageNumber.includes(index)">
                                    <span class="current" v-if="index==current_page">
                                       {{index}}
                                    </span>
                                    <span v-else>
                                       <a href="#" @click="dopagination(index)">
                                          {{index}}
                                       </a>
                                    </span>
                                 </span>
                                 <span v-if="index==last_page||index==last_page-1">
                                    <span v-if="(index==last_page-1) && lastDotted">
                                       ..
                                    </span>
                                    <span class="current" v-if="index==current_page">
                                       {{index}}
                                    </span>
                                    <span v-else>
                                       <a href="#" @click="dopagination(index)">
                                          {{index}}
                                       </a>
                                    </span>
                                 </span>
                              </span>
                           </span>
                           <span v-else>
                              <span v-for="index in last_page">
                                 <span class="current" v-if="index==current_page">
                                    {{index}}
                                 </span>
                                 <span v-else>
                                    <a href="#" @click="dopagination(index)">{{index}}</a>
                                 </span>
                              </span>
                           </span>
                           <a v-if="next_page_url" href="#" @click="dopagination(nextPage)" class="next">
                              Next »
                           </a>
                           <span v-else class="disabled">Next »</span>
                        </div>

                     </div>
                     <div class="box-footer"></div>
                  </form>
               </div>
            </div>
         </div>
      </section>
   </div>
</template>
<script>
   import axios from 'axios'
   export default {
      name: "FlexPinList",
      data() {
         return {
            userData : {},
            pinListArr : [],
            batchArr : {},
            reseller_list : {},
            login : '',
            batch_pin_serial : '',
            id_reseller : '',
            lots_id : 0,
            deviceArr : {},

            alert_message : '',
            dispplayFrom : 0,   
            dispplayTo : 0,  
            totalData : 0, 
            display_limit : 50,
            status:1,
            sl : 1,
            operation_type : 1,
            is_online : '',
            user_type : '',

            flexApiUrl : process.env.VUE_APP_APIFLEXURL,

            // Pagination Variables
            prev_page_url : false,
            next_page_url : false,
            last_page : 1,
            current_page : null,
            max_display_pagination : 9,
            randomPageNumber : {}, 
            firstDotted: false,
            lastDotted: false,
            prevPage : '',
            nextPage : '',
         }
      },
      created(){
         if(!this.com_isTVReseller()){
            this.$router.push('dashboard');
         }
         var encryptedData = this.$store.getters.getUser;
         var decodedString  = this.com_DecryptString(encryptedData);
         this.userData = JSON.parse(decodedString);
         var rootObject = this;
         loader.show();

         var rootObject = this;
         let querystr = 'idReseller='+this.userData.id_reseller+'&level='+this.userData.user_level;
         axios.get(rootObject.flexApiUrl+'/batch-pin-dropdown?'+querystr).then(function (response) {
            rootObject.batchArr = response.data.batchData;
         })
         .catch(function (error) {
            rootObject.com_errorHandel(error);
            let alertmessage = "";
            for (var prop in error.response.data) {
               alertmessage += ' '+error.response.data[prop]
            }
            console.log(alertmessage); 
         });

         axios.get('get-reseller-dropdown-data').then(function (response) {
            rootObject.reseller_list = response.data.data;
         })
         .catch(function (error) {
            rootObject.com_errorHandel(error);
            let alertmessage = "";
            for (var prop in error.response.data) {
               alertmessage += ' '+error.response.data[prop]
            }
            console.log(alertmessage); 
         });

         loader.hide();
      },
      methods: {

         dopagination(page_no = ''){
            loader.show();
            var rootObject = this;
            let querystr = 'login='+this.login+'&status='+this.status+'&paginate='+this.display_limit+'&batch_id='+this.lots_id+'&sl_of_batch_pin='+this.batch_pin_serial+'&id_reseller='+this.id_reseller+'&is_online='+this.is_online+'&idReseller='+this.userData.id_reseller+'&level='+this.userData.user_level+'&user_type='+this.user_type;

            if(page_no > 0){
               querystr +="&page="+page_no;
            }else{
               querystr +="&page=1";
            }
            //console.log(querystr);

            axios.get(rootObject.flexApiUrl+'/pins?'+querystr).then(function (response) {
               rootObject.populatePinListData(response);
            })
            .catch(function (error) {
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
                }
                console.log(alertmessage);
                loader.hide();
                rootObject.com_errorHandel(error);
            });
         },

         populatePinListData(response){
            this.sl = parseInt(response.data.from);
            var current_date_time = this.com_currentDateTime();
            var userData = this.userData;
            for (var prop in response.data.data) {
               var allowresetpin = false;
               var showPeriod = this.com_modifyDateTime(3, response.data.data[prop]['after_activate_first_login_at']);
               if(showPeriod >= current_date_time){
                  if(response.data.data[prop]['reseller_level']==userData.user_level){
                     allowresetpin = true;
                  }
               }
               response.data.data[prop]['allowresetpin'] = allowresetpin;
            }
            this.pinListArr = response.data.data;
            //console.log(this.pinListArr);

            this.totalData = response.data.total;
            this.dispplayFrom = response.data.from;
            this.dispplayTo = response.data.to;
            this.display_limit = response.data.per_page;
            this.paginationGenerate(response);
            loader.hide();
         },

         paginationGenerate(response){
            this.prev_page_url = response.data.prev_page_url;
            this.next_page_url = response.data.next_page_url;
            this.last_page = response.data.last_page;
            this.current_page = response.data.current_page;
            this.randomPageNumber = [];
            this.firstDotted = false;
            this.lastDotted = false;
            this.prevPage = this.current_page-1;
            this.nextPage = this.current_page+1;
            let countableOtherPages = this.max_display_pagination-4;
            if(this.current_page==1 || this.current_page ==2){
               for(let i = 3; i <= (3+(countableOtherPages-1)); i++){
                  this.randomPageNumber.push(i);
               }
               this.lastDotted=true;
            }
            else if(this.current_page==this.last_page || this.current_page ==this.last_page-1){
               let endPage = this.last_page-2;
               for(let i = endPage; i >= endPage - (countableOtherPages-1); i--){
                  this.randomPageNumber.push(i);
               }
               this.firstDotted = true;
            }
            else{
               let interval = parseInt(countableOtherPages / 2);
               if(this.current_page <= (interval+3)){
                  for(let i = 3; i <= (3+(countableOtherPages-1)); i++){
                     this.randomPageNumber.push(i);
                  }
                  this.lastDotted=true;
               }
               else if (this.current_page >= (this.last_page - (interval+2))) 
               {
                  let endPage = this.last_page-2;
                  for(let i = endPage; i >= endPage - (countableOtherPages-1); i--){
                     this.randomPageNumber.push(i);
                  }
                  this.firstDotted = true;
               }else{
                  for(let i = this.current_page; i <= (this.current_page+interval); i++){
                     this.randomPageNumber.push(i);
                  }

                  for(let i = (this.current_page-1); i >= (this.current_page-interval); i--){
                     this.randomPageNumber.push(i);
                  }
               }
            }
            //console.log(this.randomPageNumber);
         },

         resetPin(pin_id){
            //console.log(pin_id);
            var rootObject = this;
            let msg ="Are you sure to reset this udid?";
           
            $.confirm({
                title: 'Confirm!',
                content: msg,
                buttons: {
                    yes: function () {
                        loader.show();
                        axios.get(rootObject.flexApiUrl+'/reset-udid/'+pin_id).then(function (response)
                        {
                           //console.log(response);
                           if(response.status==200){
                              rootObject.dopagination(0);
                              rootObject.alert_message = 'UDID Reset successfully';
                              loader.hide();
                              setTimeout(function(){
                                 rootObject.alert_message = '';
                              }, 3000);
                           }

                        })
                        .catch(function (error) {
                           rootObject.com_errorHandel(error);
                           let alertmessage = "";
                           for (var prop in error.response.data) {
                               alertmessage += ' '+error.response.data[prop]
                           }
                           //console.log(alertmessage);
                           $.alert(alertmessage);
                        });
                    },
                    no: function () {
                        //return;
                    }
                }
            });
         },

         returnPin(pin_id, has_return_request){
            if(has_return_request==1){
               $.alert("You have sent return request to admin. Please, wait till refund. It takes up to 12 hours");
               return;
            }

            //console.log(pin_id);
            var rootObject = this;
            let msg ="Are you sure want to return this balance and deactivate?";
           
            $.confirm({
                title: 'Confirm!',
                content: msg,
                buttons: {
                    yes: function () {
                        loader.show();
                        axios.get(rootObject.flexApiUrl+'/return-pin/'+pin_id).then(function (response)
                        {
                           //console.log(response);
                           if(response.status==200){
                              rootObject.dopagination(0);
                              rootObject.alert_message = 'You have sent return request to admin. Please, wait till refund. It takes up to 12 hours !';
                              loader.hide();
                              setTimeout(function(){
                                 rootObject.alert_message = '';
                              }, 3000);
                           }

                        })
                        .catch(function (error) {
                           let alertmessage = "";
                           for (var prop in error.response.data) {
                               alertmessage += ' '+error.response.data[prop]
                           }
                           //console.log(alertmessage);
                           $.alert(alertmessage);
                           loader.hide();
                           rootObject.com_errorHandel(error);
                        });
                    },
                    no: function () {
                        //return;
                    }
                }
            });
         },

         checkAll(){
            if($("#check_all").prop("checked")==true){
               $('.user_id').prop('checked', 'checked');
            }else{
               $('.user_id').prop('checked', false);
            }
         },

         mulOperation(type){
            var rootObject = this;

            var checked = document.querySelectorAll('input[name="user_id[]"]:checked').length;
            if (checked == 0) {
               $.alert('Please select at least a PIN');
               return;
            }

            /*status count message start*/
            var activePins = [];
            var inActivePins = [];
            var active_count = 0;
            var inactive_count = 0;
            $('input[name="user_id[]"]:checked').each(function () {
               const status = $(this).prev().val();
               if (status == 1) {
                  active_count += 1;
                  activePins.push($(this).val());
               } else {
                  inactive_count += 1;
                  inActivePins.push($(this).val());
               }
            });
            var activate_message = (active_count > 0) ? `${active_count} PIN's is active.` : '';
            var in_activate_message = (inactive_count > 0) ? `${inactive_count} PIN's is Inactive.` : '';
            /*status count message end*/

            var activation_option = this.operation_type;

            if(activation_option==1){
               if (inactive_count < 1) {
                  $.alert("All PIN's are already active.");
                  return;
               } else {
                  var msg = ` ${activate_message} ${in_activate_message} Are you sure you want to activate ${inactive_count} PIN's?`;
               }

               var users = inActivePins;
            }

            if(activation_option==2){
               if (active_count < 1) {
                  $.alert("All PIN's are already Inactive.");
                  return;
               } else {
                  var msg = `${in_activate_message} ${activate_message} Are you sure you want to deactivate ${active_count} PIN's?`;
               }

               var users = activePins;
            }

            //console.log(users);

            $.confirm({
               title: 'Confirm!',
               content: msg,
               buttons: {
                  yes: function () {
                     loader.show();
                     const form = new FormData()
                     form.append('operation_type', activation_option)
                     form.append('idReseller', rootObject.userData.id_reseller)
                     form.append('level', rootObject.userData.user_level)
                     form.append('users', JSON.stringify(users))
                     var config = {
                        headers: { 'Content-Type': 'multipart/form-data' }
                     }
                     axios.post(rootObject.flexApiUrl+'/bulk-pin-operation', form, config).then(function (response) {
                        //console.log(response);
                        if(response.status==200){
                           rootObject.dopagination(0);
                           rootObject.alert_message = "Pin\'s "+response.data;
                           rootObject.checkAll();
                           loader.hide();
                           setTimeout(function(){
                              rootObject.alert_message = '';
                           }, 3000);
                        }
                     })
                     .catch(function (error) {
                        rootObject.com_errorHandel(error);
                        let alertmessage = "";
                        for (var prop in error.response.data) {
                            alertmessage += ' '+error.response.data[prop]
                        }
                        //console.log(alertmessage);
                        $.alert(alertmessage);
                     });
                  },
                  no: function () {
                     return;
                  }
               }
            });

            //console.log(this.operation_type);
         },

         loadDeviceList(id) {
            loader.show();
            var rootObject = this;
            axios.get(rootObject.flexApiUrl+'/device-details?id='+id).then(function (response) {
               //console.log(response.data.deviceDtls);
               rootObject.deviceArr = response.data.deviceDtls;
               setTimeout(function(){  
                  $('.colorbox').colorbox({opacity: 0.8, height: '200px', width: '80%', 'inline':true, 'open':true, href:function(){return "#viewDeviceList"; }});
                  loader.hide();
               }, 500);
               //rootObject.loadLinkPopup(id, response.data.ratePlans);
            })
            .catch(function (error) {
               //console.log(error);
               let alertmessage = "";
               for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
               }
               console.log(alertmessage);
               loader.hide();
               rootObject.com_errorHandel(error);
            });
         },

         refreshNow(){
            this.login = '';
            this.batch_pin_serial = '';
            this.id_reseller = '';
            this.lots_id = 0;
            this.display_limit = 50;
            this.status = 1;
            this.last_page = 1;
            this.pinListArr = [];
         },

         showPinPass(val) {
            let rootObject = this;
            var id = val;
            $('#passwordShowDiv_'+id).html('<img src="/assets/img/loading_h.gif" alt="Loading"/>');
            const form = new FormData()
            form.append('id', id);
            form.append('idReseller', this.userData.id_reseller);
            form.append('level', this.userData.user_level);
            var config = {
               headers: { 'Content-Type': 'multipart/form-data' }
            }
            axios.post(rootObject.flexApiUrl+'/show-pin-pass', form, config).then(function (response) {
               //console.log(response);
               if(response.status==200){ 
                  $('#passwordShowDiv_'+id).html(response.data);
               }
            })
            .catch(function (error) {
               rootObject.com_errorHandel(error);
               let alertmessage = "";
               for (var prop in error.response.data) {
                   alertmessage += ' '+error.response.data[prop]
               }
               //console.log(alertmessage);
               $.alert(alertmessage);
            });
         },

         contentEdit(id) {
            if(this.userData.id_reseller !== 393 || !this.userData.user_level==4){
               $.alert('You are not permitted to update password ! Please contact to support !');
               return;
            }
            
            var valId="#passWord-"+id;
            $(valId).prop("contenteditable", true);
         },

         updatePassword(id) {
            if(this.userData.id_reseller !== 393 || !this.userData.user_level==4){
               $.alert('You are not permitted to update password ! Please contact to support !');
               return;
            }

            var rootObject = this;
            var valId="#passWord-"+id;
            var username= $(valId).attr('username');
            var originalVal= $(valId).attr('original-value');

            var id=id;
            var newPassWord=$(valId).text();
            var newPassWord=newPassWord.replace("<br>", "");
            var newPassWord=newPassWord.replace("&nbsp;", "");
            var newPassWord=newPassWord.replace(/ /g,'');

            if(newPassWord==originalVal) return;
            if(newPassWord==username) {
               $.alert('Pin and password can not be same');
               $(valId).text(originalVal);
               return;
            }
            if(newPassWord=='') {
               $.alert('password can not be empty');
               $(valId).text(originalVal);
               return;
            }
            if(newPassWord.length<4) {
               $.alert('Min password length is 4');
               $(valId).text(originalVal);
               return;
            }

            var firstDigits = (""+newPassWord).split("")[0];
            
            /*
            if(isNaN(newPassWord)){
               $.alert('Please, input only number value as password');
               $(valId).text(originalVal); return;
            }
            */

            if (firstDigits=='0') {
               $.alert('Zero (0) is not allowed as first letter of password');
               $(valId).text(originalVal); return;
            }

            //console.log(newPassWord);
            loader.show();
            const form = new FormData()
            form.append('id', id)
            form.append('value', newPassWord)
            form.append('username', username)
            var config = {
               headers: { 'Content-Type': 'multipart/form-data' }
            }
            axios.post(rootObject.flexApiUrl+'/reset-pin-password', form, config).then(function (response)
            {
               //console.log(response);
               if(response.status==200){
                  rootObject.alert_message = response.data;
                  loader.hide();
                  setTimeout(function(){
                     rootObject.alert_message = '';
                  }, 3000);
               }
               
            })
            .catch(function (error) {
               loader.hide();
               rootObject.com_errorHandel(error);
               let alertmessage = "";
               for (var prop in error.response.data) {
                   alertmessage += ' '+error.response.data[prop]
               }
               //console.log(alertmessage);
               $.alert(alertmessage);
            });

            $(valId).text(newPassWord);
            $(valId).css("cursor", "default");
            $(valId).prop("contenteditable", false);
         },
      },

      mounted: function() {
         var rootObject = this;
         $("#lots_id").on('change', function(){
            $('#batch_pin_serial').val('');
            if(this.value != 0){
               $('#batch_pin_serial').attr('disabled', false);
            }else{
               $('#batch_pin_serial').val('').attr('disabled', true);
            }
         });

         $(".select2").select2();
      }
      

   };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   .text-yellow{
      color: #f39c12 !important;
   }
   .text-green{
      color: #00a65a !important;
   }
</style>